import { __extends } from "tslib";
import { TextEvent } from './TextEvent';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: ErrorEvent
var ErrorEvent = /** @class */ (function (_super) {
    __extends(ErrorEvent, _super);
    function ErrorEvent(type, bubbles, cancelable, text, id) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (text === void 0) { text = ''; }
        if (id === void 0) { id = 0; }
        var _this = _super.call(this, type, bubbles, cancelable, text) || this;
        _this.setID(id);
        return _this;
    }
    ErrorEvent.prototype.setID = function (id) {
        this._id = id;
    };
    Object.defineProperty(ErrorEvent.prototype, "errorID", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    ErrorEvent.prototype.clone = function () {
        return new ErrorEvent(this.type, this.bubbles, this.cancelable, this.text, this.errorID);
    };
    ErrorEvent.prototype.toString = function () {
        return this.formatToString('ErrorEvent', 'type', 'bubbles', 'cancelable', 'text', 'errorID');
    };
    ErrorEvent.classInitializer = null;
    ErrorEvent.classSymbols = null;
    ErrorEvent.instanceSymbols = null;
    // JS -> AS Bindings
    ErrorEvent.ERROR = 'error';
    return ErrorEvent;
}(TextEvent));
export { ErrorEvent };
